<template>
  <div>
    <LoadingIndicator v-if="isLoading" class="product-recommendations-cards-small__loader" />
    <ProductRecommendationsCardSmall
      v-else
      v-for="item in items"
      :item="item"
      :key="item.id"
      :context="context"
      @select-size="$emit('select-size', $event)"
    />
  </div>
</template>

<script>
import ProductRecommendationsCardSmall from './ProductRecommendationsCardSmall.vue'
import LoadingIndicator from '@/components/_shared/LoadingIndicator.vue'

export default {
  name: 'ProductRecommendationsCardsSmall',
  components: {
    ProductRecommendationsCardSmall,
    LoadingIndicator,
  },

  props: {
    isLoading: {
      type: Boolean,
    },
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    context: {
      type: String,
    },
    onSelectSize: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.product-recommendations-cards-small {
  &__loader {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
